import { Cart } from "Store/cart/cartInterfaces";
import { getNumberOfProductsInCartFromCookie } from "Utils/cookies/cookiesUtil";
import { isDefined, isNull } from "Utils/functions";
import { getProductEditQueryParams } from "Utils/navigation/queryParameterUtils";

const incrementIfNotExistingProduct = (
  productsInCart: number,
  productId: string | null,
): number => {
  if (productId !== null) {
    return productsInCart;
  }
  return productsInCart + 1;
};

const getNumberOfProductsFromCart = (cart: Cart | null): number => {
  if (!isNull(cart)) {
    return cart.products.length;
  }
  const numberOfProductsInCartFromCookie =
    getNumberOfProductsInCartFromCookie();

  if (isDefined(numberOfProductsInCartFromCookie)) {
    return Number(numberOfProductsInCartFromCookie);
  }
  return 0;
};

export const getNumberOfProductsCustomerWillHaveInCartIncludedThisOne = (
  cart: Cart | null,
): number => {
  const { productId } = getProductEditQueryParams();
  const productsInCart = getNumberOfProductsFromCart(cart);
  return incrementIfNotExistingProduct(productsInCart, productId);
};
